import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatProductPriceEur, resolveProductDisplay } from '../utils/campaignWebCreator';
import { resolveShapeRadius } from '../utils/defaults';

export default function ProductCardView({ comp, checkoutEnabled, onBuy }) {
  const props = comp.props || {};
  const {
    imageUrl,
    price,
    buttonLabel,
    campaignId,
    productId,
    stancerConfigured,
    shape,
    borderRadius,
  } = props;
  const { title, description } = resolveProductDisplay(props);

  const radius = resolveShapeRadius(shape, borderRadius);
  const linked = Boolean(campaignId && productId);
  const hasDisplay = Boolean(
    linked || imageUrl || title || description || price != null,
  );

  const canBuy =
    checkoutEnabled &&
    linked &&
    stancerConfigured &&
    Number(price) > 0;

  const handleBuy = () => {
    if (!canBuy) return;
    onBuy?.({
      compId: comp.id,
      campaignId,
      productId,
      title: title || 'Produit',
      description: description || '',
      imageUrl: imageUrl || '',
      price,
      buttonLabel: buttonLabel || 'Acheter',
    });
  };

  if (!hasDisplay) {
    return (
      <div
        className="w-full h-full flex flex-col items-center justify-center gap-2 border border-dashed border-border bg-muted/30 text-center p-4"
        style={{ borderRadius: `${radius}px` }}
      >
        <Icon name="ShoppingBag" size={28} className="text-muted-foreground/50" />
        <p className="text-xs text-muted-foreground">Produit — choisissez une campagne</p>
      </div>
    );
  }

  const showPrice = price != null && Number.isFinite(Number(price));

  return (
    <div
      className="w-full h-full flex flex-col overflow-hidden border border-border bg-card shadow-sm min-h-0"
      style={{ borderRadius: `${radius}px` }}
    >
      <div className="relative w-full shrink-0 aspect-[4/3] max-h-[45%] bg-muted overflow-hidden">
        {imageUrl ? (
          <img src={imageUrl} alt="" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground/40">
            <Icon name="Image" size={36} />
          </div>
        )}
      </div>

      <div className="flex flex-col flex-1 min-h-0 p-3 sm:p-4 gap-2 overflow-hidden">
        <h3 className="text-sm sm:text-base font-semibold text-foreground leading-snug line-clamp-2 shrink-0">
          {title || 'Produit'}
        </h3>
        {description ? (
          <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed line-clamp-3 flex-1 min-h-0 overflow-hidden">
            {description}
          </p>
        ) : (
          <div className="flex-1 min-h-0" />
        )}
        {showPrice ? (
          <p className="text-base sm:text-lg font-bold text-foreground tabular-nums shrink-0">
            {formatProductPriceEur(price)}
            <span className="text-xs font-normal text-muted-foreground ml-1">TTC</span>
          </p>
        ) : linked ? (
          <p className="text-xs text-muted-foreground shrink-0">Prix non défini</p>
        ) : null}
        {linked ? (
          <button
            type="button"
            disabled={checkoutEnabled && !canBuy}
            onClick={handleBuy}
            className={`w-full py-2 px-3 rounded-lg text-sm font-semibold transition-smooth shrink-0 ${
              canBuy
                ? 'bg-primary text-primary-foreground hover:opacity-90 shadow-sm'
                : checkoutEnabled
                  ? 'bg-muted text-muted-foreground cursor-not-allowed'
                  : 'bg-primary/90 text-primary-foreground cursor-default'
            }`}
          >
            {buttonLabel || 'Acheter'}
          </button>
        ) : (
          <p className="text-[10px] text-center text-muted-foreground shrink-0 px-1">
            Liez une campagne pour activer le paiement
          </p>
        )}
        {checkoutEnabled && linked && !stancerConfigured ? (
          <p className="text-[10px] text-amber-600 text-center shrink-0">Paiement non configuré</p>
        ) : null}
      </div>
    </div>
  );
}
